import { PROFICIENCY_LIST_COUNT } from '../../../settings.js'
import connector from '../../connector.js'

/**
 * Get tag
 * @param {Object} options
 * @param {number} options.id Category ID
 */
export function get ({ id }) {
  return connector.get(`proficiency/categories/${id}`).json()
}

/**
 * Get tag list
 * @param {Object} filter Filter options
 * @param {string} filter.search Search term
 * @param {number} filter.offset Offset value
 * @param {number} [filter.limit=100] Number of results
 * @param {import('ky').Options} [options] Request options
 */
export function getList ({ search, offset, limit = PROFICIENCY_LIST_COUNT }, options) {
  const searchParams = { limit, search, offset }
  return connector.get('proficiency/categories', { searchParams, ...options }).json()
}

/**
 * Create new tag
 * @param {Object} options
 * @param {Object} options.data Category data
 */
export function create ({ data }) {
  return connector.post('proficiency/categories', data).json()
}

/**
 * Update existing tag
 * @param {Object} options
 * @param {number} options.id Category ID
 * @param {Object} options.data Category data
 */
export function update ({ id, data }) {
  return connector.patch(`proficiency/categories/${id}`, data).json()
}

/**
 * Remove tag
 * @param {Object} options
 * @param {number} options.id Category ID
 */
export function remove ({ id }) {
  return connector.delete(`proficiency/categories/${id}`)
}

export function preflight (id) {
  return connector.get(`proficiency/categories/${id}/delete-preflight`).json()
}
